import { Typography } from "@bigbinary/neeto-atoms";
import classnames from "classnames";
import { isPresent } from "neetocist";
import { useBreakpoints } from "neetocommons/react-utils";

import IntegrationItem from "./IntegrationItem";
import Item from "./Item";

const Category = ({ items, label, id, isIntegration }) => {
  const { isSize } = useBreakpoints();
  const SettingsCard = isIntegration ? IntegrationItem : Item;
  const isMobileOrTablet = isSize("mobile") || isSize("tablet");

  const isLabelPresent = isPresent(label);

  return (
    <div
      {...{ id }}
      className={classnames("flex flex-col", { "mb-7": isLabelPresent })}
    >
      {isLabelPresent && (
        <Typography asChild variant="h2" weight="semibold">
          <h2 className="mt-2 mb-6" data-testid="settings-category-heading">
            {label}
          </h2>
        </Typography>
      )}
      <div
        className={classnames(
          "grid grid-cols-1 gap-3 py-1 md:grid-cols-2 lg:grid-cols-2 lg:gap-4",
          {
            "xl:grid-cols-2 2xl:grid-cols-3": isIntegration,
            "xl:grid-cols-3 2xl:grid-cols-4": !isIntegration,
          }
        )}
      >
        {items.map(item => (
          <SettingsCard
            key={item.label}
            {...item}
            {...(isIntegration && { isMobileOrTablet })}
          />
        ))}
      </div>
    </div>
  );
};

export default Category;
